/// Needs tests
import axios, { AxiosResponse } from 'axios';
import { addMessage } from '../state/actions/messagesActions';
import { touchCookie } from './analytics/userInterestAnalytics';;
import getCookie from '../utils/getCookie';
import qs from 'qs';

import { PagedResponse } from '../types/api/Http';
import { ArticleIndexItem, ArticleQuery, ArticleFilterConfig } from '../types/api/AcademyTypes';
import { Dispatch } from 'redux';

import { ENV } from '../constants/environments';
import { BROWSER_FINGERPRINT_COOKIE_NAME } from '../constants/utils';

const apiUrl = `${ENV.api.baseURL}/edu_assets`;

export const getContent = async (params: object, slug = null) => {
  const url = !slug ? apiUrl : apiUrl + '/' + slug
  const urlParams = params;
  const response = await axios.get(url + '?' + urlParams);
  return response?.data;
};

export const getCategoryContent = async (params: object) => {
  const urlParams = params;
  const response = await axios.get(apiUrl + '?' + urlParams);
  return response?.data;
};

const getFilterableSpecs = (article: any): Record<string, string[]> | null => {
  if (!article?.specs || !Array.isArray(article.specs) || article.specs.length === 0) {
    return null;
  }

  const filterableTypes = ['Software', 'Technique', 'Category'];
  const result: Record<string, string[]> = {};

  article.specs.forEach((item) => {
    if (item.type && item.value && filterableTypes.includes(item.type)) {
      if (!result[item.type]) {
        result[item.type] = [];
      }
      result[item.type].push(item.value);
    }
  });

  return Object.keys(result).length > 0 ? result : null;
};

const getArticles = async (dispatch: Dispatch, query?: ArticleQuery): Promise<PagedResponse<ArticleIndexItem>> => {
  try {
    const params = { ...query };
    touchCookie();
    const browser_fingerprint = getCookie(BROWSER_FINGERPRINT_COOKIE_NAME);
    params.user_token = [browser_fingerprint];
    const result: AxiosResponse<PagedResponse<ArticleIndexItem>> = await axios.get('/api/articles', {
      params,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' })
    });
    return result.data;
  } catch (e) {
    dispatch(addMessage({
      body: e?.message || 'An error has occured',
      type: 'error',
    }));
    return;
  }
};

const getFilters = async (dispatch: Dispatch): Promise<ArticleFilterConfig[]> => {
  if (sessionStorage.getItem('academy-filters'))
    return JSON.parse(sessionStorage.getItem('academy-filters')) as ArticleFilterConfig[];
  try {
    const result: AxiosResponse<ArticleFilterConfig[]> = await axios.get('/api/articles/filters');
    sessionStorage.setItem('academy-filters', JSON.stringify(result.data));
    return result.data;
  } catch (e) {
    dispatch(addMessage({
      body: e?.message || 'An error has occured',
      type: 'error',
    }));
    return;
  }
};

const academyIndexHelpers = {
  getContent,
  getCategoryContent,
  getFilterableSpecs,
  getArticles,
  getFilters,
}

export default academyIndexHelpers;
